import React, { useState } from 'react';
import ProductsPage from '../../components/ProductsPage/ProductsPage';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faTimes } from '@fortawesome/free-solid-svg-icons';
import './PageProductos.css';
import HeaderBack from '../../components/HeaderBack/HeaderBack';
import Modal from 'react-modal';
import Profile from '../../components/Profile/Profile';

export default function PageProductos() {
    const [perfilModalOpen, setPerfilModalOpen] = useState(false);

    const perfilBtn = (
        <button onClick={() => setPerfilModalOpen(true)} aria-label="Perfil">
            <FontAwesomeIcon icon={faUser} />
        </button>
    );

    return (
        <div>
            <div className='bgPage'>
                <HeaderBack title='Productos' rightSlot={perfilBtn} />
                <div className='bgPageBreadcrumb'>
                    <Anchor to={`/`}>
                        <FontAwesomeIcon icon={faHome} /> Inicio
                    </Anchor>
                    <span className='breadcrumbSeparator'>|</span>
                    <Anchor to=''>Productos</Anchor>
                </div>
            </div>

            <ProductsPage />

            <Modal
                isOpen={perfilModalOpen}
                onRequestClose={() => setPerfilModalOpen(false)}
                className="modal-perfil"
                overlayClassName="overlay"
            >
                <div className="modal-perfil-header">
                    <span>Mi perfil</span>
                    <button onClick={() => setPerfilModalOpen(false)} aria-label="Cerrar">
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="modal-perfil-body">
                    <Profile />
                </div>
            </Modal>
        </div>
    );
}
